export default "__VITE_ASSET__BqNE24HZ__"